module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN303_419408758.c3644fa2.png";